export default __webpack_public_path__ + "static/media/img9.4d6f18ad.jfif";